import { NgModule } from "@angular/core";

import { ElementContainerRegistry } from "./element-container-registry.service";

@NgModule({
  providers: [ElementContainerRegistry]
})
export class ElementContainerModule {}
